export const SET_CATEGORIES = 'menu/setCategories';
export const CREATE_UPDATE_CATEGORY = 'menu/createUpdateCategory';
export const REMOVE_CATEGORY = 'menu/removeCategory';
export const CREATE_UPDATE_PRODUCT = 'menu/createUpdateProduct';
export const REMOVE_PRODUCT = 'menu/removeProduct';
